import {
  readingCompleted,
  readingCompletedTimestamp,
  readingCompensation,
  readingEntryCompleted,
  userId,
} from '../constants/stringsAndFields';
import {FAVORITE_QUOTE_TABLE} from '../database/favoriteQuote';
import {NOTE_TABLE} from '../database/note';
import {READING_PLAN_PROGRESS_TABLE} from '../database/readingPlanProgress';
import {exportDatabase, runSqlCmd} from '../database/sqlOperations';
import {APP_USER_TABLE} from '../database/user';
import {LOCAL_DEFAULT_USER_ID} from '../database/userConstants';
import {USER_SETTINGS_TABLE} from '../database/userSettings';

function escapeSql(value) {
  if (value == null) {
    return '';
  }
  return String(value).replace(/'/g, "''");
}

/**
 * Reassigns offline rows (local default user) to the signed-in Supabase user id
 * so existing notes / favorites / plan progress stay with the account.
 */
export async function mergeLocalDefaultUserIntoRemote(db, remoteUserId) {
  const rid = escapeSql(remoteUserId);
  const local = escapeSql(LOCAL_DEFAULT_USER_ID);
  await runSqlCmd(
    db,
    `UPDATE ${NOTE_TABLE} SET ${userId} = '${rid}' WHERE ${userId} = '${local}';`,
  );
  await runSqlCmd(
    db,
    `UPDATE ${FAVORITE_QUOTE_TABLE} SET ${userId} = '${rid}' WHERE ${userId} = '${local}';`,
  );
  await runSqlCmd(
    db,
    `UPDATE ${READING_PLAN_PROGRESS_TABLE} SET ${userId} = '${rid}' WHERE ${userId} = '${local}';`,
  );
}

/**
 * Removes this account’s local SQLite rows (explicit deletes so CASCADE does not rely on PRAGMA foreign_keys).
 * Reading plan rows stay in the DB: they are reassigned to the offline default user with progress reset.
 */
export async function deleteRemoteUserLocalData(db, remoteUserId) {
  const rid = escapeSql(remoteUserId);
  await runSqlCmd(
    db,
    `DELETE FROM ${NOTE_TABLE} WHERE ${userId} = '${rid}';`,
  );
  await runSqlCmd(
    db,
    `DELETE FROM ${FAVORITE_QUOTE_TABLE} WHERE ${userId} = '${rid}';`,
  );
  const local = escapeSql(LOCAL_DEFAULT_USER_ID);
  await runSqlCmd(
    db,
    `UPDATE ${READING_PLAN_PROGRESS_TABLE} SET
      ${userId} = '${local}',
      ${readingCompleted} = 0,
      ${readingCompletedTimestamp} = NULL,
      ${readingEntryCompleted} = 0,
      ${readingCompensation} = 0
    WHERE ${userId} = '${rid}';`,
  );
  await runSqlCmd(
    db,
    `DELETE FROM ${USER_SETTINGS_TABLE} WHERE ${userId} = '${rid}';`,
  );
  await runSqlCmd(
    db,
    `DELETE FROM ${APP_USER_TABLE} WHERE ${userId} = '${rid}';`,
  );
  await exportDatabase(db);
}
